import ULThemeLogo from "@/components/ULThemeLogo";
import ULThemeTitle from "@/components/ULThemeTitle";

export const Header = () => {
  return (
    <div className="text-center">
      <ULThemeLogo altText="solace-logo"></ULThemeLogo>
      <ULThemeTitle>Loading...</ULThemeTitle>
    </div>
  );
};
